"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // src/utils/simple-logger.ts

var _datefns = require('date-fns');

var info = function info(_ref) {
  var isLoggingEnabled = _ref.isLoggingEnabled,
      message = _ref.message;

  if (!isLoggingEnabled) {
    return;
  }

  var response = {
    message: message,
    timestamp: _datefns.format.call(void 0, /* @__PURE__ */new Date(), "yyyy-MM-dd-HH:mm:ss")
  };
  console.info(response);
  return response;
};

exports.info = info;